/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Calm_Heron_FlyInputs */

const en_warm_calm_heron_fly = /** @type {(inputs: Warm_Calm_Heron_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

const de_warm_calm_heron_fly = /** @type {(inputs: Warm_Calm_Heron_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

/**
* | output |
* | --- |
* | "Segment" |
*
* @param {Warm_Calm_Heron_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_calm_heron_fly = /** @type {((inputs?: Warm_Calm_Heron_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Calm_Heron_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_calm_heron_fly(inputs)
	return de_warm_calm_heron_fly(inputs)
});